module.exports = __webpack_public_path__ + "static/media/btw.a20ec0ff.jpg";